import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tippy';

import './styles.scss';

const propTypes = {
  content: PropTypes.string.isRequired,
  image: PropTypes.string
};
const defaultProps = {
  content: 'Default help text'
};

class QuestionMark extends Component {
  render() {
    const { content, image } = this.props;
    let input;

    if (image) {
      input = (
        <Tooltip
          animation="fade"
          arrow={true}
          html={<img src={require(`../../../images/${image}`)} alt={image} />}
          position="right"
          trigger="mouseenter"
        >
          <i className="question-mark icon-question" />
        </Tooltip>
      );
    } else {
      input = (
        <Tooltip animation="fade" arrow={true} position="right" title={content} trigger="mouseenter">
          <i className="question-mark icon-question" />
        </Tooltip>
      );
    }

    return input;
  }
}

QuestionMark.propTypes = propTypes;
QuestionMark.defaultProps = defaultProps;

export default QuestionMark;
